export class FeatureAccessError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'FeatureAccessError';
  }
}
